import { render, staticRenderFns } from "./BuildingFilterItem.vue?vue&type=template&id=c1e27f38&scoped=true&"
import script from "./BuildingFilterItem.vue?vue&type=script&lang=js&"
export * from "./BuildingFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e27f38",
  null
  
)

export default component.exports